export { default } from "./AttachmentItem";
